// extracted by mini-css-extract-plugin
export default {"sus":"Sus_sus__-CZQY","Worst":"Sus_Worst__dIxEM","Poor":"Sus_Poor__QyQ4C","OK":"Sus_OK__XuBKV","Good":"Sus_Good__tYNaj","Excellent":"Sus_Excellent__edcho","Best":"Sus_Best__oOLDH"};